var map = {
	"./en.json": 800,
	"./fr.json": 801,
	"./zh_TW.json": 802
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 799;


//////////////////
// WEBPACK FOOTER
// ./src/locale ^\.\/.*\.json$
// module id = 799
// module chunks = 0